// ======================================================================
// File Name       : MultiLanguageList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import _ from 'lodash';
import React from 'react';
import { Button, Col, Table } from 'react-bootstrap';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { changeMultiLanguageStatus, convertLanguageShortName } from '../../utils/ContentUtils';
import { parseDateForDetail } from '../../utils/index';
import ReduxFormPaging from '../ReduxFormPaging';
import { MULTI_LANGUAGE_EDIT } from '../../constants/PathConstants';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../button/CustomLink';

const thead = [
  { title: 'コンテンツ識別ID', sortBy: 0, width: 250 },
  { title: 'コンテンツ名', sortBy: 1 },
  { title: 'ステータス', sortBy: 3, width: 165 },
  { title: '更新日', sortBy: 4, width: 165 },
  { title: '操作', sortBy: null, width: 110 },
];
class MultiLanguageList extends React.Component {
  constructor(props) {
    super(props);
    this.getLanguageNameList = this.getLanguageNameList.bind(this);
  }

  getLanguageNameList(languageCodeList) {
    let languageNames = [];

    // #7073 START
    const sortedLanguageCodeList = _.sortBy(languageCodeList, languageCode =>
      SELECT_BOX_DATA.TRANSLATION_LANGUAGE_SHORT_NAME.findIndex(obj => obj.value === languageCode),
    );
    sortedLanguageCodeList.map((languageCode) => {
      languageNames.push(convertLanguageShortName(languageCode));
      return null;
    });
    // #7073 END

    languageNames = languageNames.join('・');
    if (languageNames.lastIndexOf('・') === languageNames.length - 1) {
      languageNames = languageNames.slice(0, languageNames.lastIndexOf('・'));
    }
    return languageNames;
  }

  render() {
    const {
      documentMultiLanguageList,
      handleSortState,
      goToEdit,
      invalid,
      handleMouseEnter,
      handleMouseLeave,
      hoverIndex,
      recordNum,
      getStartEndData,
    } = this.props;
    const { allSecernIds, bySecernId } = documentMultiLanguageList;
    const tbody = allSecernIds.map((contentSecernId, index) => {
      const {
        contentName,
        multiLanguageStatus,
        languageCodeList,
        updatedAt,
      } = bySecernId[
        contentSecernId
      ];
      const link = MULTI_LANGUAGE_EDIT.replace(':id', contentSecernId);
      return (
        <tr key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
          <td>
            <div>{contentSecernId}</div>
          </td>
          <td>
            {contentName}
          </td>
          <td>
            {changeMultiLanguageStatus(multiLanguageStatus)}
          </td>
          <td>
            {parseDateForDetail(updatedAt)}
          </td>
          <td className="text-center">
            <CustomLink
              className="margin-right-7 link-detail-edit"
              to={link}
              text="編集"
            />
          </td>
        </tr>
      );
    });

    return (
      <div>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="documentMultiLanguageSortType"
              invalid={invalid}
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
        <Col sm={12} className="text-center">
          <Col className="d-flex justify-content-center">
            <ReduxFormPaging
              type="paging"
              name="startPosition"
              recordNum={recordNum}
              getStartEndData={getStartEndData}
            />
          </Col>
        </Col>
      </div>
    );
  }
}
export default MultiLanguageList;
